import React from 'react';
import SupportChatWorkspace from '../../components/admin/SupportChatWorkspace';

export default function DealerSupportChat() {
  return (
    <div className="p-6">
      <SupportChatWorkspace user_type="dealer" title="Dealer Support Chat Workspace" />
    </div>
  );
}
